// extracted by mini-css-extract-plugin
module.exports = {"assignTokensContainer":"_5DUtELYV","description":"_5D1ceMuj"};